module.exports = __webpack_public_path__ + "img/4.f592c4da.png";